var $ec2dceffa5b2d037$exports = {};
$ec2dceffa5b2d037$exports = {
    "loading": `Na\u{10D}\xedt\xe1n\xed...`,
    "loadingMore": `Na\u{10D}\xedt\xe1n\xed dal\u{161}\xedch...`
};


export {$ec2dceffa5b2d037$exports as default};
//# sourceMappingURL=cs-CZ.module.js.map
